if($('.interactive-map-component').length) {
    require('./map/interactive');
}
